import { AxiosError } from 'axios';

import { curriculumGateway } from '../curriculum-gateway';

import { ProgrammeRecommendation } from '@features/programmes';

import { Country } from '@types';

const handleWriteError = (error: AxiosError): never => {
    if (error.response?.status === 422) {
        throw new Error(
            'A recommendation already exists for this working level and year.',
        );
    }

    throw new Error('Please refresh the page or try again.');
};

export const getProgrammeRecommendations = async (
    country = Country.GB,
): Promise<ProgrammeRecommendation[]> => {
    return curriculumGateway
        .get(`/programme_recommendations`, {
            withCredentials: true,
            params: { country },
        })
        .then((response) => response.data)
        .catch(() => {
            throw new Error(
                'Something went wrong loading the recommendations.',
            );
        });
};

export const createProgrammeRecommendation = async (
    params: Partial<ProgrammeRecommendation>,
): Promise<ProgrammeRecommendation> => {
    return curriculumGateway
        .post(
            `/programme_recommendations`,
            { programme_recommendation: params },
            { withCredentials: true },
        )
        .then((response) => response.data)
        .catch(handleWriteError);
};

export const updateProgrammeRecommendation = async (
    id: number | undefined,
    params: Partial<ProgrammeRecommendation>,
): Promise<ProgrammeRecommendation> => {
    return curriculumGateway
        .put(
            `/programme_recommendations/${id}`,
            { programme_recommendation: params },
            { withCredentials: true },
        )
        .then((response) => response.data)
        .catch(handleWriteError);
};

export const deleteProgrammeRecommendation = async (id: number | undefined) => {
    return curriculumGateway
        .delete(`/programme_recommendations/${id}`, {
            withCredentials: true,
        })
        .catch(() => {
            throw new Error('Please refresh the page or try again.');
        });
};
